// Thin fetch wrappers around the JSON API. The app is public — no auth.
import type { Listing, UpdateListingPayload } from "@/types";

async function jsonOrThrow<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`${res.status} ${res.statusText}: ${body}`);
  }
  return res.json() as Promise<T>;
}

export function fetchListings(): Promise<Listing[]> {
  return fetch("/api/listings").then(jsonOrThrow<Listing[]>);
}

export function fetchListing(id: string): Promise<Listing> {
  return fetch(`/api/listings/${encodeURIComponent(id)}`).then(
    jsonOrThrow<Listing>,
  );
}

export function updateListing(
  id: string,
  patch: UpdateListingPayload,
): Promise<Listing> {
  return fetch(`/api/listings/${encodeURIComponent(id)}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  }).then(jsonOrThrow<Listing>);
}
